<template>
  <div class="page" v-loading="loading">
    <div class="page-head">
      <div>
        <div class="kicker">知行悦房旅 · 账号信息</div>
        <h2>个人信息</h2>
        <p class="sub">查看并修改当前登录后台账号的基本资料</p>
      </div>
      <div class="head-actions">
        <el-button size="small" @click="openProfile">编辑资料</el-button>
        <el-button size="small" type="primary" @click="openPwd">修改密码</el-button>
      </div>
    </div>

    <div class="hero">
      <div class="avatar">{{ avatarText }}</div>
      <div class="hero-main">
        <div class="name-row">
          <span class="name">{{ displayName }}</span>
          <el-tag size="mini" :type="statusType">{{ statusText }}</el-tag>
          <el-tag size="mini" type="warning">{{ roleText }}</el-tag>
        </div>
        <div class="hero-meta">后台登录账号 · {{ user.userName || '—' }}</div>
      </div>
    </div>

    <div class="cards">
      <div class="card" v-for="item in fields" :key="item.label">
        <div class="card-label">{{ item.label }}</div>
        <div class="card-value">
          <span v-if="item.key !== 'passWord'">{{ item.value }}</span>
          <span v-else class="pwd-row">
            <span>{{ showPwd ? (user.passWord || '—') : '••••••••' }}</span>
            <el-button type="text" size="mini" @click="showPwd = !showPwd">{{ showPwd ? '隐藏' : '显示' }}</el-button>
          </span>
        </div>
      </div>
    </div>

    <el-dialog title="编辑资料" :visible.sync="profileVisible" width="460px">
      <el-form ref="profileForm" :model="profile" :rules="profileRules" label-width="88px" size="small">
        <el-form-item label="用户名" prop="userName">
          <el-input v-model="profile.userName" maxlength="20" placeholder="登录账号"></el-input>
        </el-form-item>
        <el-form-item label="显示名称" prop="name">
          <el-input v-model="profile.name" maxlength="30" placeholder="如 管理员"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="profile.mobile" maxlength="11" placeholder="11位手机号"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="profile.email" maxlength="50" placeholder="邮箱"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="profileVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="saving" @click="saveProfile">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改密码" :visible.sync="pwdVisible" width="460px">
      <el-form ref="pwdForm" :model="pwd" :rules="pwdRules" label-width="88px" size="small">
        <el-form-item label="原密码" prop="oldPassWord">
          <el-input v-model="pwd.oldPassWord" type="password" placeholder="请输入原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassWord">
          <el-input v-model="pwd.newPassWord" type="password" placeholder="4到8位字母或数字"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirm">
          <el-input v-model="pwd.confirm" type="password" placeholder="再次输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="pwdVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="saving" @click="savePwd">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMyself, updateMyself } from '../../api/userMG'

export default {
  name: 'accountInformation',
  data() {
    const checkConfirm = (rule, value, callback) => {
      if (value !== this.pwd.newPassWord) callback(new Error('两次输入的密码不一致'))
      else callback()
    }
    return {
      loading: false,
      saving: false,
      showPwd: false,
      user: {},
      profileVisible: false,
      pwdVisible: false,
      profile: {
        userName: '',
        name: '',
        mobile: '',
        email: ''
      },
      pwd: {
        oldPassWord: '',
        newPassWord: '',
        confirm: ''
      },
      profileRules: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        mobile: [{ pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' }],
        email: [{ type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }]
      },
      pwdRules: {
        oldPassWord: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPassWord: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9]{4,8}$/, message: '新密码需为4到8位字母或数字', trigger: 'blur' }
        ],
        confirm: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: checkConfirm, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    displayName() {
      return this.user.userName || this.user.name || '管理员'
    },
    avatarText() {
      const name = this.displayName
      return name ? String(name).slice(0, 1).toUpperCase() : '管'
    },
    statusText() {
      if (this.user.status === false || this.user.status === 0) return '已禁用'
      return '正常'
    },
    statusType() {
      if (this.user.status === false || this.user.status === 0) return 'danger'
      return 'success'
    },
    roleText() {
      if (this.user.role === 1 || this.user.role === '1') return '学院账号'
      return '管理员'
    },
    fields() {
      const u = this.user || {}
      return [
        { key: 'userName', label: '用户名', value: u.userName || '—' },
        { key: 'passWord', label: '登录密码', value: u.passWord || '—' },
        { key: 'mobile', label: '手机号', value: u.mobile || '未填写' },
        { key: 'email', label: '邮箱', value: u.email || '未填写' },
        { key: 'name', label: '所属名称', value: u.name || '—' },
        { key: 'createdAt', label: '创建时间', value: this.fmtTime(u.createdAt) }
      ]
    }
  },
  created() {
    this.load()
  },
  methods: {
    fmtTime(val) {
      if (!val) return '—'
      return String(val).replace('T', ' ').slice(0, 19)
    },
    applyUser(user) {
      this.user = user || {}
      localStorage.setItem('userdata', JSON.stringify(this.user))
    },
    load() {
      this.loading = true
      getMyself({}).then(res => {
        this.loading = false
        if (res && res.status === 200 && res.data) {
          this.applyUser(res.data)
          return
        }
        this.fallback()
        this.$message.error((res && res.message) || '账号信息加载失败')
      }, () => {
        this.loading = false
        this.fallback()
        this.$message.error('账号信息加载失败')
      })
    },
    fallback() {
      try {
        const cached = JSON.parse(localStorage.getItem('userdata') || '{}')
        if (cached && cached.userName) this.user = cached
      } catch (e) {}
    },
    openProfile() {
      this.profile = {
        userName: this.user.userName || '',
        name: this.user.name || '',
        mobile: this.user.mobile || '',
        email: this.user.email || ''
      }
      this.profileVisible = true
      this.$nextTick(() => {
        this.$refs.profileForm && this.$refs.profileForm.clearValidate()
      })
    },
    openPwd() {
      this.pwd = { oldPassWord: '', newPassWord: '', confirm: '' }
      this.pwdVisible = true
      this.$nextTick(() => {
        this.$refs.pwdForm && this.$refs.pwdForm.clearValidate()
      })
    },
    saveProfile() {
      this.$refs.profileForm.validate(valid => {
        if (!valid) return
        this.saving = true
        updateMyself({
          userName: this.profile.userName,
          name: this.profile.name,
          mobile: this.profile.mobile,
          email: this.profile.email
        }).then(res => {
          this.saving = false
          if (!res || res.status !== 200) {
            this.$message.error((res && res.message) || '保存失败')
            return
          }
          const body = res.data || {}
          this.applyUser(body.user || body)
          this.profileVisible = false
          this.$message.success('资料已更新')
        }, err => {
          this.saving = false
          this.$message.error((err && (err.response && err.response.data && err.response.data.message) || err.message) || '保存失败')
        })
      })
    },
    savePwd() {
      this.$refs.pwdForm.validate(valid => {
        if (!valid) return
        this.saving = true
        updateMyself({
          oldPassWord: this.pwd.oldPassWord,
          newPassWord: this.pwd.newPassWord
        }).then(res => {
          this.saving = false
          if (!res || res.status !== 200) {
            this.$message.error((res && res.message) || '修改失败')
            return
          }
          const body = res.data || {}
          if (body.token) localStorage.setItem('logintoken', body.token)
          if (body.user) this.applyUser(body.user)
          this.pwdVisible = false
          this.$message.success('密码已更新')
        }, err => {
          this.saving = false
          this.$message.error((err && (err.response && err.response.data && err.response.data.message) || err.message) || '修改失败')
        })
      })
    }
  }
}
</script>

<style scoped>
.page {
  padding: 8px 4px 32px;
  max-width: 960px;
}
.page-head {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.head-actions {
  flex-shrink: 0;
}
.kicker {
  color: #8b5cf6;
  font-size: 13px;
  letter-spacing: 1px;
  margin-bottom: 6px;
  font-weight: 600;
}
.page-head h2 {
  margin: 0;
  color: #1f1633;
  font-size: 24px;
}
.sub {
  margin: 8px 0 0;
  color: #6b6480;
  font-size: 13px;
}
.hero {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #5b67f1 0%, #8b5cf6 48%, #ff6b6b 130%);
  border-radius: 20px;
  padding: 28px 32px;
  color: #fff;
  box-shadow: 0 16px 36px rgba(91, 103, 241, 0.28);
  margin-bottom: 20px;
}
.avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  border: 2px solid #ffd56a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 700;
  margin-right: 20px;
  flex-shrink: 0;
}
.hero-main {
  min-width: 0;
}
.name-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.name {
  font-size: 22px;
  font-weight: 700;
  margin-right: 12px;
  line-height: 1.3;
}
.name-row >>> .el-tag {
  margin: 0 8px 0 0;
}
.hero-meta {
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 13px;
}
.cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.card {
  background: #fff;
  border-radius: 16px;
  padding: 18px 20px;
  box-shadow: 0 10px 24px rgba(91, 103, 241, 0.08);
}
.card-label {
  color: #6b6480;
  font-size: 13px;
  margin-bottom: 8px;
}
.card-value {
  color: #1f1633;
  font-size: 16px;
  font-weight: 600;
  word-break: break-all;
}
.pwd-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pwd-row >>> .el-button {
  color: #8b5cf6;
  padding: 0;
}
@media (max-width: 720px) {
  .cards {
    grid-template-columns: 1fr;
  }
  .hero {
    padding: 20px;
  }
  .page-head {
    flex-direction: column;
    align-items: flex-start;
  }
  .head-actions {
    margin-top: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/information.vue